import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

//import { AppRoutingModule } from './app-routing.module';
import { routing } from './app-routing.module';

import { AppComponent } from './app.component';
import { DiningGuideOldComponent } from './dining-guide-old.component';
import { DiningGuideComponent } from './dining-guide.component';
import { DiningGuideRegionComponent } from './dining-guide-region.component';
import { CoreModule } from '../core/core.module';

@NgModule({
  declarations: [
    AppComponent,
    DiningGuideOldComponent,
    DiningGuideComponent,
    DiningGuideRegionComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,

    //AppRoutingModule,
    routing,
    CoreModule
  ],
  exports: [
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
